// ❗ Logo SVG must be imported with ?raw suffix

import { defineThemeConfig } from '@core';
import { RouteTransitions, Skins } from '@core/enums';
import logo from '@images/logo.png';
import { VIcon } from 'vuetify/components/VIcon';

import { AppContentLayoutNav, ContentWidth, FooterType, NavbarType } from '@layouts/enums';

export const { themeConfig, layoutConfig } = defineThemeConfig({
  app: {
    title: 'careezy',
    logo: h('img', {
      src: logo,
      alt: 'app-logo',
      style: 'line-height:0; color: rgb(var(--v-global-theme-primary)); width: 180px'
    }),
    contentWidth: ContentWidth.Fluid,
    contentLayoutNav: AppContentLayoutNav.Horizontal,
    overlayNavFromBreakpoint: 1358 + 16, // 16 for scrollbar. Docs: https://next.vuetifyjs.com/en/features/display-and-platform/
    enableI18n: false,
    theme: 'system',
    isRtl: false,
    skin: Skins.Default,
    routeTransition: RouteTransitions.Fade,
    iconRenderer: VIcon
  },
  navbar: {
    type: NavbarType.Sticky,
    navbarBlur: true
  },
  footer: { type: FooterType.Static },
  verticalNav: {
    isVerticalNavCollapsed: false,
    defaultNavItemIconProps: { icon: 'tabler-circle', size: 10 },
    isVerticalNavSemiDark: false
  },
  horizontalNav: {
    type: 'sticky',
    transition: 'slide-y-reverse-transition'
  },
  icons: {
    chevronDown: { icon: 'tabler-chevron-down' },
    chevronRight: { icon: 'tabler-chevron-right', size: 18 },
    close: { icon: 'tabler-x' },
    verticalNavPinned: { icon: 'tabler-circle-dot' },
    verticalNavUnPinned: { icon: 'tabler-circle' },
    sectionTitlePlaceholder: { icon: 'tabler-separator' }
  }
});
